import React, { useCallback } from 'react';
import { Link, router, usePage } from '@inertiajs/react';
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
    DropdownMenuSeparator, DropdownMenuTrigger,
} from '../../ui/dropdown-menu';
import { useTrans } from '../../../hooks/useTrans';
import LanguageSwitcher from '../../LanguageSwitcher';

export default function Header({ onMenuToggle }) {
    const { auth, routes, locales } = usePage().props;
    const t = useTrans();

    const handleLanguageSwitch = useCallback((languageKey) => {
        router.post(routes.profileUpdate, {
            _method: 'PUT',
            language_submit: '',
            language_id: locales[languageKey]?.language_id,
        });
    }, [routes.profileUpdate, locales]);

    return (
        <header className="bg-[#003545] text-white">
            <div className="flex items-center justify-between px-4 h-16">
                <div className="flex items-center gap-3">
                    <button onClick={onMenuToggle} className="lg:hidden cursor-pointer text-white">
                        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>
                    <a href={routes.home} title="Schotpoort Connect">
                        <img src="/assets/img/layout/schotpoort-logo.svg" alt="Schotpoort Connect" className="h-8 w-[221px]" />
                    </a>
                </div>

                <div className="flex items-center">
                    <a href={routes.manual} className="hidden sm:block rounded-md border-2 border-[#ffd500] bg-[#ffd500] px-3 py-1 text-sm font-black text-[#003545] hover:bg-transparent hover:text-[#ffd500] transition-colors">
                        {t('Download handleiding')}
                    </a>

                    {auth && (
                        <>
                            <DropdownMenu>
                                <DropdownMenuTrigger asChild>
                                    <button className="cursor-pointer h-16 px-4 text-white focus:outline-none">
                                        <span className="hidden sm:inline text-[14px]">{t('Ingelogd als')} {auth.name}</span>
                                        <svg className="sm:hidden h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                                        </svg>
                                    </button>
                                </DropdownMenuTrigger>
                                <DropdownMenuContent align="end" className="w-[280px] bg-[#003545] border-none rounded-[2px] p-0">
                                    <DropdownMenuLabel className="bg-[#022833] p-4 text-[16px] font-bold text-white">
                                        {t('Welkom')} {auth.name}
                                    </DropdownMenuLabel>
                                    {auth.canEditProfile && (
                                        <DropdownMenuItem asChild className="p-0 focus:bg-[#ffd400] focus:text-[#003545]">
                                            <Link href={routes.profileEdit} className="block cursor-pointer p-4 text-[14px] font-bold text-white/50 hover:text-[#003545]">
                                                {t('Profiel bewerken')}
                                            </Link>
                                        </DropdownMenuItem>
                                    )}
                                    <DropdownMenuItem asChild className="p-0 focus:bg-[#ffd400] focus:text-[#003545]">
                                        <Link href={routes.settings} className="block cursor-pointer p-4 text-[14px] font-bold text-white/50 hover:text-[#003545]">
                                            {t('Instellingen')}
                                        </Link>
                                    </DropdownMenuItem>
                                    <DropdownMenuSeparator className="m-0 bg-white/10" />
                                    <div className="p-4">
                                        <button
                                            type="button"
                                            onClick={() => router.post(routes.logout)}
                                            className="w-full cursor-pointer rounded-sm border-2 border-[#0e8e6a] bg-[#0e8e6a] px-4 py-1.5 text-[14px] font-black text-white hover:bg-transparent hover:text-[#0e8e6a] transition-colors"
                                        >
                                            {t('Uitloggen')}
                                        </button>
                                    </div>
                                </DropdownMenuContent>
                            </DropdownMenu>

                            <LanguageSwitcher onSwitch={handleLanguageSwitch} />
                        </>
                    )}
                </div>
            </div>
        </header>
    );
}
